import { createI18n } from 'vue-i18n';
import zh_TW from './langConfig/zh_TW.json';
import en_US from './langConfig/en_US.json';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en_US',
  fallbackLocale: 'en_US',
  messages: {
    zh_TW,
    en_US,
  },
});
export default i18n;
